// @vocab-ignore

export const Empty = () => (
  <svg
    id="b"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 88 76.24068"
    width="120"
    height="60"
  >
    <g id="c">
      <path
        d="m55.29228,36.10059h-22.58447c-6.19141,0-11.22852-5.03711-11.22852-11.22852v-13.64355c0-6.19141,5.03711-11.22852,11.22852-11.22852h22.58447c6.19141,0,11.22852,5.03711,11.22852,11.22852v13.64355c0,6.19141-5.03711,11.22852-11.22852,11.22852ZM32.70781,7.68555c-1.9541,0-3.54395,1.58887-3.54395,3.54297v13.64355c0,1.9541,1.58984,3.54297,3.54395,3.54297h22.58447c1.9541,0,3.54395-1.58887,3.54395-3.54297v-13.64355c0-1.9541-1.58984-3.54297-3.54395-3.54297h-22.58447Z"
        fill="#0d3880"
        strokeWidth="0"
      />
      <rect
        x="2.20129"
        y="33.08627"
        width="83.59743"
        height="43.15441"
        rx="6"
        ry="6"
        fill="#f470bd"
        strokeWidth="0"
      />
      <path
        d="m82.67746,44.69832l-38,4.31818c-.45019.05116-.90473.05116-1.35492,0l-38-4.31818c-3.03207-.34455-5.32254-2.91005-5.32254-5.96163v-17.18656c0-3.31371,2.68629-6,6-6h76c3.31371,0,6,2.68629,6,6v17.18656c0,3.05158-2.29048,5.61708-5.32254,5.96163Z"
        fill="#ee399e"
        strokeWidth="0"
      />
      <rect
        x="35.80419"
        y="43.80174"
        width="16.39162"
        height="9.17931"
        rx="1.16108"
        ry="1.16108"
        fill="#f7f8fb"
        strokeWidth="0"
      />
    </g>
  </svg>
);
